import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {
  const [collegeId, setCollegeId] = useState("");
  const [pass, setPass] = useState("");
  const navigate = useNavigate();

  const handleLogin = () => {
    axios
      .post("http://dietdubacherla.in/diet_backend/admin_login.php", {
        college_id: collegeId,
        pass: pass,
      })
      .then((res) => {
        if (res.data.status === "success") {

  const user = {
    ...res.data.admin,
    role: "admin",
  };

  localStorage.setItem(
    "user",
    JSON.stringify(user)
  );

          alert("Admin Login Success");
          navigate("/admin-dashboard");
        } else {
          alert(res.data.message || "Login failed");
        }
      })
      .catch((err) => {
        console.log(err);
        alert("Server error");
      });
  };

  return (
    <div style={container}>
      <div style={card}>
        <img
          src="/logo.jpeg"
          alt="logo"
          style={{ width: "100px", marginBottom: "15px" }}
        />

        <h2 style={{ color: "#b30000" }}>
          Admin Login
        </h2>

        <input
          type="text"
          placeholder="College ID"
          value={collegeId}
          onChange={(e) => setCollegeId(e.target.value)}
          style={input}
        />

        <input
          type="password"
          placeholder="Password"
          value={pass}
          onChange={(e) => setPass(e.target.value)}
          style={input}
        />

        <button
          onClick={handleLogin}
          style={button}
        >
          Login
        </button>
      </div>
    </div>
  );
}

const container = {
  minHeight: "80vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "#f5f5f5",
};

const card = {
  width: "350px",
  background: "white",
  padding: "30px",
  borderRadius: "10px",
  textAlign: "center",
  boxShadow: "0 0 15px rgba(0,0,0,0.1)",
};

const input = {
  width: "100%",
  padding: "12px",
  margin: "10px 0",
  border: "1px solid #ccc",
  borderRadius: "5px",
};

const button = {
  width: "100%",
  padding: "12px",
  background: "#b30000",
  color: "white",
  border: "none",
  cursor: "pointer",
  borderRadius: "5px",
};